export const COOKIE_CONSENT_STORAGE_KEY = 'sokoloco_cookie_consent';
// Bump whenever the banner/policy changes materially — mismatched or missing
// version means the stored choice is stale, so the banner shows again for everyone.
export const COOKIE_CONSENT_VERSION = 2;

// Cheap existence check (doesn't parse/validate prefs) — used by components that
// only need to know whether the consent banner is about to render, not its contents.
export function hasStoredCookieConsent(): boolean {
    try {
        const raw = localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
        if (!raw) return false;
        const parsed = JSON.parse(raw);
        return parsed.version === COOKIE_CONSENT_VERSION;
    } catch {
        return false;
    }
}
